import imageFragment from 'js/graphqlFragments/ImageFragment';

const fetchData = (pageId: number): string => `
    {
    page(id: "${pageId}", idType: DATABASE_ID) {
      TrainingTemplate {
        titleOffer
        descriptionOffer
        offerings {
          courseTitle
          productsTab {
            linkText
            linkButton {
            ... on Post {
              link
            }
            ... on Page {
              link
            }
            ... on ArticlesSingle {
              link
            }
            ... on CoursesSingle {
              link
            }
            ... on VideosSingle {
              link
            }
            ... on ManualsSingle {
              link
            }
          }
            inThisTraining {
              item
            }
            aboutThisTraining
            productName
            videoButton {
              buttonLabel
              videoLink
              videoPreview {
                ...ImageFragmentVideoPreview
              }
            }
          }
        }
      }
    }
  }
  ${imageFragment('VideoPreview')} 
`;
export default fetchData;
